import config from '@config';
import {
  initializeHttp,
  setupCookieUnauthorizedInterceptorFabric,
  setupCsrfInterceptor,
  setupOrganizationSessionInterceptor,
  setupRequestInterceptor,
  setupServerErrorInterceptor,
} from '@gasbi/shared/common/utils/http';

// Cookie (BFF) session (GSB-7612): every request carries X-CSRF for the API's CSRF guard,
// and a 401 (no session) navigates to the BMS API's login endpoint. The active organization
// lives in that session too (GSB-8274): a 403 organization_unavailable re-reads it.
const instance = initializeHttp(config.VITE_API_URL, [
  setupRequestInterceptor,
  setupOrganizationSessionInterceptor,
  setupCsrfInterceptor,
  setupCookieUnauthorizedInterceptorFabric('/api/login'),
  setupServerErrorInterceptor,
]);

export default instance;
